import {
	Table, Popconfirm, Pagination, Checkbox
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import './style.css'
import {
	useDebounce
}from 'use-debounce'
import "antd/lib/spin/style/index.css"
import {
	reOrgActions
}from './store/actions'
import CustomButton from '../../../components/CustomButton'
import Notifications from '../../../helpers/Notifications'
import CustomInput from '../../../components/CustomInput'
import LocalLoading from '../../../components/Loading/Local'
import DeleteIcon from '../../../components/Icons/delete.svg'
import UpdateIcon from '../../../components/Icons/update.svg'
import AddIcon from '../../../components/Icons/add.svg'
import ChangeReOrg from './change'

const ReOrgs = ({ isModify = false }) => {
	const [search, setSearch] = useState(null)
	const [page, setPage] = useState(1)
	const [record, setRecord] = useState(null)
	const [visible, setVisible] = useState(false)

	const { paged, isSending, changed } = useSelector(state => state.reOrgReducer)

	const pageSize = 10
	const [searchValue] = useDebounce(search, 500)
	const dispatch = useDispatch()

	const columns = [
		{
			dataIndex : 'unp',
			inputType : 'text',
			key       : 'UNP',
			title     : 'УНП'

		},
		{
			dataIndex : 'fullName',
			inputType : 'text',
			key       : 'fullName',
			title     : 'Полное название'
		},
		{
			dataIndex : 'shortName',
			inputType : 'text',
			key       : 'shortName',
			title     : 'Сокращенное название'
		},
		{
			dataIndex : ['reOrgType', 'name'],
			inputType : 'text',
			key       : 'reOrgType',
			title     : 'Тип'
		},
		{
			dataIndex : ['reOrgStatusType', 'name'],
			inputType : 'text',
			key       : 'reOrgStatusTypeId',
			title     : 'Статус'
		}
	]

	const getPaged = (values) => {
		dispatch(reOrgActions.getPaged(values))
	}
	const remove = (values) => {
		dispatch(reOrgActions.remove(values))
	}

	useEffect(() => {
		onPaginationChange(1)
	}, [searchValue])

	useEffect(() => {
		return () => {
			dispatch(reOrgActions.clear())
		}
	}, [])

	useEffect(() => {
		if (changed){
			Notifications.successNotice(changed, "", 15)
			onPaginationChange(page)
		}
	}, [changed])

	const onPaginationChange = (page) => {
		setPage(page)
		getPaged({
			name     : searchValue,
			page     : page,
			pageSize : pageSize
		})
	}

	isModify
		? columns.push({
			dataIndex : 'isEnteredManually',
			inputType : 'bool',
			key       : 'isEnteredManually',
			title     : 'Добавлена вручную',
			width     : "5%",
			align     : "center",
			render    : checked => (
				<Checkbox
					checked={ checked }
				/>
			  )
		}, {
			dataIndex : 'dateUpdate',
			inputType : 'text',
			key       : 'dateUpdate',
			title     : 'Дата обновления'
		}, {
			dataIndex : "id",
			key       : 'id',
			width     : 100,
			render    : (id, record) => (
				<div className="changeIcon">
					<img
						src={ UpdateIcon }
						title="Редактировать"
						onClick={ () => {
							setVisible(true)
							setRecord(record)
						} }
					/>
					<Popconfirm
						cancelText="Нет"
						okText="Да"
						placement="left"
						title="Вы уверены, что хотите навсегда удалить данную запись?"
						onCancel={ (e) => {
							e.stopPropagation()
							return null
						} }
						onConfirm={ (e) => {
							e.stopPropagation()
							remove({ id })
						} }
					>
						<img
							src={ DeleteIcon }
							title="Удалить"
						/>
					</Popconfirm>
				</div>
			)
		})
		: null

	return (
		<>
			<div className="header-admin-nsi">
				<CustomInput
					maxLength={ 64 }
					placeholder="Введите название/УНП"
					onChange={ (e) => setSearch(e.target.value) }
				/>
				{ isModify
					? (
						<CustomButton
							className="add-nsi"
							type="green"
							onClick={ () => {
								setRecord(null)
								setVisible(true)
							} }
						>
							<div>
								<img src={ AddIcon } />
								<span>
                  Добавить
								</span>
							</div>
						</CustomButton>
					)
					: null }
			</div>
			<Table
				columns={ columns }
				dataSource={ paged?.items }
				loading={ { indicator : <LocalLoading />,
					spinning  : isSending } }
				pagination={ false }
				scroll={ { x: 1200 } }
			/>
			{ paged?.count > pageSize
				? (
					<Pagination
						showQuickJumper
						current={ page }
						pageSize={ pageSize }
						showSizeChanger={ false }
						size="small"
						total={ paged?.count }
						onChange={ onPaginationChange }
					/>)
				: null }
			{ isModify &&
				<ChangeReOrg
					record={ record }
					setRecord={ setRecord }
					setVisible={ setVisible }
					visible={ visible }
				/> }
		</>
	)
}

export default ReOrgs